export default __webpack_public_path__ + "static/media/mario2.c5809144.jpg";